module.exports = __webpack_public_path__ + "static/media/no-content1.7434c6c5.png";